namespace RedBullMOBILE360.Settings {
    export interface ServiceParametersForm {
        Name: Serenity.StringEditor;
        AuthToken: Serenity.StringEditor;
        OfferId: Serenity.StringEditor;
    }

    export class ServiceParametersForm extends Serenity.PrefixedContext {
        static formKey = 'Settings.ServiceParameters';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!ServiceParametersForm.init)  {
                ServiceParametersForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;

                Q.initFormType(ServiceParametersForm, [
                    'Name', w0,
                    'AuthToken', w0,
                    'OfferId', w0
                ]);
            }
        }
    }
}
